---
title: "Reading the Analytics Dashboard"
slug: viewing-analytics
description: "Overview of the Analytics Dashboard: reading Impact, Activity Report, Inventory Health, and Location Performance."
keywords:
  - analytics
  - dashboard
  - impact
  - activity report
  - inventory health
  - location performance
  - CO2
---

## Prerequisites

- Role: Manager or Company Admin
- At least some scan events must have occurred in the selected period

## Steps

1. Navigate to **Analytics** in the top menu.
2. Select the desired period in the top-right corner: for example **Last 7 days**, **Last 30 days**, **Last month**, **Last 90 days**, **Year to date**, or **Custom range**.
3. Read the **Impact** section: this shows the number of shipments, CO₂ saved, and waste saved for the selected period.
4. Review the **Activity Report**: the monthly scan volume chart shows how many shipments were recorded per month.
5. Open **Inventory Health**: here you see the total number of your boxes broken down by status (Active, Defect, Near EOL, End of Life) along with the defect rate by location.
6. Check **Location Performance**: the table lists all locations with scan volume, average dwell time, defect rate, and stock imbalance. An **Imbalance** or **Severe imbalance** badge indicates that more packages are flowing in one direction than returning.

## If something goes wrong

- **"No data for selected period"** — No scans were recorded during this period. Select a larger period or check whether scans occurred in the past few days.
- **"No location data for the selected period"** — No scans were recorded for individual locations during the selected period.
- **Figures differ from expectations** — Check that the selected period is correct. Data is calculated from completed scan events.
- Contact us: support@heycircle.com or use the feedback button in the bottom-right corner of the screen.

## Related Articles

- [Receiving a Package](/app/help?article=scanning-a-package)
- [Sending a Package](/app/help?article=sending-a-package)
- [Initial Setup](/app/help?article=initial-setup)
